module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container__card order-card",
    attrs: {
      "id": "card"
    }
  }, [_c('div', {
    staticClass: "wrapper-position",
    on: {
      "click": function($event) {
        _vm.checkFoMobileAndNavigate()
      }
    }
  }, [_c('div', {
    staticClass: "brand-logo",
    attrs: {
      "id": "brand-logo"
    }
  }, [(_vm.brandLogo) ? _c('img', {
    staticClass: "left-padding",
    class: _vm.logoPosition,
    attrs: {
      "src": _vm.brandLogo
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "title left-padding",
    style: (_vm.themeColor)
  }, [_vm._v("Your Order")])]), _vm._v(" "), _c('div', {
    staticClass: "order-card-wrapper"
  }, [_c('div', {
    staticClass: "body-content",
    class: {
      'multiple-line-items': _vm.checkout.lineItems.length > 1
    }
  }, [_c('div', {
    staticClass: "sub-heading items",
    style: (_vm.themeColor)
  }, [_c('div', {
    staticClass: "clearfix"
  }, [(_vm.checkout.lineItems.length == 1) ? [_c('p', {
    staticClass: "text-large amount"
  }, [_vm._v("\n              " + _vm._s(_vm.totalAmount) + "\n              "), _c('span', {
    staticClass: "single-item-tax",
    attrs: {
      "id": "single-item-tax"
    }
  }, [_vm._v(" + taxes extra")])]), _vm._v(" "), _c('p', {
    staticClass: "text-large package-name"
  }, [_vm._v("\n              " + _vm._s(_vm.checkout.lineItems[0].name) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n              " + _vm._s(_vm.checkout.lineItems[0].description) + "\n            ")])] : [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "text-large amount"
  }, [_vm._v(_vm._s(_vm.totalAmount))]), _vm._v(" "), (_vm.checkout.itemsWithoutDiscounts().length > 1) ? _c('p', {
    staticClass: "text-large"
  }, [_vm._v(_vm._s(_vm.checkout.itemsWithoutDiscounts().length) + " items in total")]) : _vm._e(), _vm._v(" "), (_vm.checkout.itemsWithoutDiscounts().length == 1) ? _c('p', {
    staticClass: "text-large"
  }, [_vm._v(_vm._s(_vm.checkout.itemsWithoutDiscounts()[0].name) + " ")]) : _vm._e()])]], 2), _vm._v(" "), _c('p', {
    staticClass: "shipping-text"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }, [_vm._v("Change")])])])]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [(_vm.checkout.discountItems().length >= 1) ? _c('div', {
    staticClass: "clearfix discount"
  }, [_c('div', {
    staticClass: "dim clearfix"
  }, [_c('p', {
    staticClass: "left"
  }, [_vm._v("Discount")]), _vm._v(" "), _c('p', {
    staticClass: "total-text"
  }, [_vm._v("-" + _vm._s(_vm.checkout.discountsWithSymbol()))])])]) : _vm._e(), _vm._v(" "), (_vm.checkout.lineItems.length > 1 || _vm.isMobile) ? _c('div', {
    staticClass: "total-footer clearfix"
  }, [_c('p', {
    staticClass: "left",
    attrs: {
      "id": "tax-text"
    }
  }, [_vm._v("Your final bill amount.")]), _vm._v(" "), _c('p', {
    staticClass: "right total-bill show",
    class: {
      'border-top': _vm.checkout.discountItems().length >= 1
    }
  }, [_vm._v(_vm._s(_vm.finalAmount))])]) : _vm._e(), _vm._v(" "), (_vm.showCouponSection) ? [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.discountCodeShown),
      expression: "!discountCodeShown"
    }],
    staticClass: "coupon",
    on: {
      "click": function($event) {
        _vm.discountCodeShown = true
      }
    }
  }, [_vm._v("Have a discount code?")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discountCodeShown),
      expression: "discountCodeShown"
    }],
    staticClass: "new-user-dicount-section clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountCode),
      expression: "discountCode"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "Enter Code"
    },
    domProps: {
      "value": _vm._s(_vm.discountCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discountCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "theme-background right",
    on: {
      "click": function($event) {
        _vm.applyCoupon($event)
      }
    }
  }, [_vm._v("APPLY")])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        _vm.initAboutCB()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Secured by Chargebee")]), _vm._v(" "), _c('div', {
    staticClass: "secured-content",
    class: {
      'show': _vm.showAboutChargebee
    }
  }, [_c('p', [_vm._v("Chargebee is PCI level 1 complaint, which means your information is very safe")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c53721a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckoutStepOrderSummary.vue
// module id = 77
// module chunks = 0